var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"version-badge caption-s"},[_vm._v(" v"+_vm._s(_vm.version)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }